import { Injectable } from '@angular/core';
import { IPlanningGenerationSelection } from '../models/planning-generation-selection.model';
import { IPlanningGenerationSummary } from '../models/planning-generation-summary.model';
import { CostAccountingRequestService } from '../services/cost-accounting-request.request.service';
import { Observable } from 'rxjs';
import { Moment } from 'moment';
import { Params } from '@angular/router';
import { IPlannedPurchasePrice } from '../models/planned-purchase-price.model';
import { IAddPurchasePricePlanning } from '../models/add-planned-purchase-price.model';
import { IUpdatePurchasePricePlanning } from '../models/update-planned-purchase-price.model';

const BASE_URL: string = 'planned-purchase-price';
const DATEFORMAT: string = 'YYYY-MM-DD';


@Injectable({
    providedIn: 'root',
})
export class PlannedPurchasePriceResource {
    constructor(private myCostAccountingRequestService: CostAccountingRequestService) {
    }

    public getPlannedPurchasePrices(articleId?: number, startDate?: Moment, endDate?: Moment): Observable<IPlannedPurchasePrice[]> {
        const params: Params = {};
        if (articleId) {
            params[ 'articleId' ] = articleId;
        }
        if (startDate && endDate) {
            params[ 'startDate' ] = startDate.format(DATEFORMAT);
            params[ 'endDate' ] = endDate.format(DATEFORMAT);
        }
        return this.myCostAccountingRequestService.get<IPlannedPurchasePrice[]>(BASE_URL, { params });
    }

    public addPlannedPurchasePrice(values: IAddPurchasePricePlanning): Observable<IPlannedPurchasePrice> {
        return this.myCostAccountingRequestService.post(BASE_URL, values);
    }

    public updatePlannedPurchasePrice(id: number, values: IUpdatePurchasePricePlanning): Observable<IPlannedPurchasePrice> {
        return this.myCostAccountingRequestService.patch(`${BASE_URL}/${id}`, values);
    }

    public deletePlannedPurchasePrice(id: number): Observable<void> {
        return this.myCostAccountingRequestService.delete(`${BASE_URL}/${id}`);
    }

    public generatePrices(generationSelection: IPlanningGenerationSelection): Observable<IPlanningGenerationSummary> {
        return this.myCostAccountingRequestService.post(`${BASE_URL}/generate`, generationSelection);

    }
}
